import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutesEnums, RoutesAddonsEnums } from '../../../enums/RoutesEnums';
import { SearchWidgetDataItem } from '../../../types/SearchWidgetDataItem';
import { Breadcrumb } from '../../../types/Breadcrumb';
import { RelatedCategoryConfigService } from './related-category-config.service';

@Injectable({
  providedIn: 'root',
})
export class RelatedNavigationService {
  private configService = inject(RelatedCategoryConfigService);

  /**
   * Extract category type from route parameters
   */
  public getCategoryTypeFromRoute(route: ActivatedRoute): RoutesAddonsEnums {
    return route.snapshot.params['categoryType'];
  }

  /**
   * Extract category slug from route parameters (removes suffix)
   */
  public getCategorySlugFromRoute(route: ActivatedRoute): string {
    const categorySlug = route.snapshot.params['categorySlug'];
    return categorySlug ? categorySlug.replace(/(-c|-s|-t)$/, '') : null;
  }

  /**
   * Build breadcrumbs for category page
   */
  public buildCategoryBreadcrumbs(categoryType: RoutesAddonsEnums): Breadcrumb[] {
    const config = this.configService.getCategoryConfig(categoryType);

    return [
      {
        routeParams: ['/', RoutesEnums.RELATED, categoryType],
        routeQueryParams: null,
        anchor: config.typeName,
      }
    ];
  }

  /**
   * Build breadcrumbs for category details page
   */
  public buildCategoryDetailsBreadcrumbs(
    categoryType: RoutesAddonsEnums,
    selectedItem: SearchWidgetDataItem | null
  ): Breadcrumb[] {
    const config = this.configService.getCategoryConfig(categoryType);
    const breadcrumbs: Breadcrumb[] = [];

    // Add category breadcrumb
    breadcrumbs.push({
      routeParams: ['/', RoutesEnums.RELATED, categoryType],
      routeQueryParams: null,
      anchor: config.typeName,
    });

    // Add item breadcrumb if available
    if (selectedItem) {
      breadcrumbs.push({
        routeParams: null,
        routeQueryParams: null,
        anchor: selectedItem.name,
      });
    }

    return breadcrumbs;
  }

  /**
   * Generate back router link for category details page
   */
  public getBackRouterLink(categoryType: RoutesAddonsEnums | null): string[] {
    if (categoryType) {
      return ['/', RoutesEnums.RELATED, categoryType];
    }
    return ['/', RoutesEnums.RELATED];
  }

  /**
   * Update search state based on category type and slug
   */
  public updateSearchState(
    useState: any,
    categoryType: RoutesAddonsEnums,
    categorySlug: string
  ): void {
    switch (categoryType) {
      case RoutesAddonsEnums.RELATED_CARESERVICE:
        useState.careServiceTypeUrlPath = categorySlug;
        break;
      case RoutesAddonsEnums.RELATED_SYMPTOM:
        useState.symptomUrlPath = categorySlug;
        break;
      case RoutesAddonsEnums.RELATED_CAREPROVIDER:
      default:
        useState.caregiverUnitTypeUrlPath = categorySlug;
        break;
    }
  }
}
